import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type SettingUpdate = {
  id?: number;
  name: string;
  value: string;
};

type RequestParams = {
  settings: SettingUpdate[];
  createIfNotExists?: boolean;
};

export const updateOrganizationSettings = async (
  scope: RequestScope,
  { settings, createIfNotExists = true }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<any>> => {
  try {
    const queryParam = createIfNotExists ? '?createIfNotExists=1' : '';
    const response = await scopedApi(scope).put<EndpointResponse<any>>(`organization/setting/bulk${queryParam}`, settings, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
